export const globalVar = {
    requestPrefix: '/do',
    searchByLanguage: '/i18n/searchByLanguage/',
    defaultTablePageSize: 10,
    defaultTableRowsPerPageOptions: [10, 20, 25, 50],
    analysisSearchResultExportMaxRows: 10000
};
